import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getProfileApi, updateProfileApi, changePasswordApi, verifyEmailApi } from '../../api/profileApi';
import {
  FETCH_PROFILE_REQUEST,
  UPDATE_PROFILE_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  VERIFY_EMAIL_REQUEST
} from '../constants/profileConstants';
import {
  fetchProfileSuccess,
  fetchProfileFailure,
  updateProfileSuccess,
  updateProfileFailure,
  changePasswordSuccess,
  changePasswordFailure,
  verifyEmailSuccess,
  verifyEmailFailure
} from '../actions/profileActions';

function* fetchProfileSaga(action) {
  try {
    const almataId = action.payload;
    const response = yield call(getProfileApi, almataId);
    yield put(fetchProfileSuccess(response.response));
  } catch (error) {
    yield put(fetchProfileFailure(error.response?.data?.message || error.message));
  }
}

function* updateProfileSaga(action) {
  try {
    const profileData = action.payload;
    const response = yield call(updateProfileApi, profileData);
    yield put(updateProfileSuccess(profileData));
        toast.success(response.message || response.data?.message || "Profile updated successfully!");
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(updateProfileFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* changePasswordSaga(action) {
  try {
    const passwordData = action.payload;
    const response = yield call(changePasswordApi, passwordData);
    yield put(changePasswordSuccess(response.data));
    toast.success(response.message || response.data?.message || "Password changed successfully!");
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(changePasswordFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* verifyEmailSaga(action) {
  try {
    const emailData = action.payload;
    const response = yield call(verifyEmailApi, emailData);
    yield put(verifyEmailSuccess(response.data));
    toast.success(response.message || response.data?.message || "Email verification sent successfully!");
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(verifyEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

export default function* profileSaga() {
  yield takeEvery(FETCH_PROFILE_REQUEST, fetchProfileSaga);
  yield takeEvery(UPDATE_PROFILE_REQUEST, updateProfileSaga);
  yield takeEvery(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeEvery(VERIFY_EMAIL_REQUEST, verifyEmailSaga);
}